/**
 * localStorage is used ONLY to suppress duplicate Lead tracking events for the same
 * normalized phone within 24 hours. It NEVER blocks a resubmission and NEVER blocks
 * WhatsApp — shared phones and shared devices are common in this audience.
 */

const KEYS = {
  lastSubmission: 'lastSubmission',
  leadPhone: 'leadPhone',
  leadName: 'leadName',
  leadVehicle: 'leadVehicle',
} as const

const DAY_MS = 24 * 60 * 60 * 1000

export function normalizePhone(phone: string): string {
  return phone.replace(/\D/g, '')
}

function read(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

function write(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    /* ignore */
  }
}

/** True when the same phone already fired a Lead event in the last 24h. */
export function isDuplicateLead(phone: string): boolean {
  const storedPhone = read(KEYS.leadPhone)
  const last = read(KEYS.lastSubmission)
  if (!storedPhone || !last) return false
  if (storedPhone !== normalizePhone(phone)) return false
  const elapsed = Date.now() - Number(last)
  return Number.isFinite(elapsed) && elapsed < DAY_MS
}

export function rememberLead(input: { phone: string; name: string; vehicle: string }): void {
  write(KEYS.lastSubmission, String(Date.now()))
  write(KEYS.leadPhone, normalizePhone(input.phone))
  write(KEYS.leadName, input.name)
  write(KEYS.leadVehicle, input.vehicle)
}

export function getStoredLead(): { name: string; vehicle: string } {
  return {
    name: read(KEYS.leadName) ?? '',
    vehicle: read(KEYS.leadVehicle) ?? '',
  }
}
